import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class FileUploadService {

  private removeFile$ = new Subject<string>();
  onRemoveFile$ = this.removeFile$.asObservable();

  requestRemoval(nameForUpload: string) {
    this.removeFile$.next(nameForUpload);
  }
}
